var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToilet = function SvgToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "toilet_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#toilet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.961 21.5a.78.78 0 0 1-.575-.232.78.78 0 0 1-.232-.576V14.5H4.46a.78.78 0 0 1-.575-.232.78.78 0 0 1-.232-.575V9q0-.633.433-1.066A1.45 1.45 0 0 1 5.154 7.5h2.692q.633 0 1.066.434.434.433.434 1.066v4.693q0 .342-.232.575a.78.78 0 0 1-.576.232h-.692v6.192q0 .344-.232.576a.78.78 0 0 1-.576.232zm11.347 0a.78.78 0 0 1-.576-.232.78.78 0 0 1-.232-.576V16h-1.375a.76.76 0 0 1-.627-.316.78.78 0 0 1-.144-.701l1.734-6.479q.142-.483.527-.744.382-.26.885-.26.502 0 .885.26.384.261.526.744l1.735 6.479a.78.78 0 0 1-.144.7.76.76 0 0 1-.627.317H18.5v4.692q0 .344-.232.576a.78.78 0 0 1-.576.232zM6.5 6.462q-.71 0-1.201-.492a1.63 1.63 0 0 1-.491-1.2q0-.71.491-1.201A1.63 1.63 0 0 1 6.5 3.077q.71 0 1.2.491.492.492.492 1.201T7.701 5.97a1.63 1.63 0 0 1-1.201.492m11 0q-.71 0-1.201-.492a1.63 1.63 0 0 1-.491-1.2q0-.71.491-1.201a1.63 1.63 0 0 1 1.201-.492q.71 0 1.2.491.493.492.492 1.201 0 .71-.491 1.201a1.63 1.63 0 0 1-1.201.492M12.25 3.25v17.5"
  }))));
};
export default SvgToilet;